<template>
  <div
    class="w-full group p-2 rounded duration-200 hover:scale-110 hover:outline hover:outline-1 hover:outline-primary cursor-pointer drop-shadow-[0_10px_15px_rgba(29,155,240,0.25)]"
    @click="OpenModal()">
    <img v-lazy="{ src: meme.image, loading: meme.blurred_thumbnail }" class="rounded-md"
      @click="($event) => checkForMemePack($event.target, this)" />
    <div class="pt-2 flex">
      <img :src="imageSrc" class="h-8 w-8 md:h-12 md:w-12 rounded-full" />
      <div class="flex flex-col ml-2 w-full">
        <span
          class="text-sm md:text-md text-foreground font-bold break-all text-ellipsis whitespace-nowrap max-w-[60%] overflow-auto">{{
            meme.display_name
          }}</span>
        <a class="text-xs md:text-sm text-subtitle break-all hover:text-primary"
          :href="'https://twitter.com/' + meme.author.substring(1)" target="_blank">{{ meme.author }}</a>
        <div class="flex justify-between">
          <span v-if="isMemePack" class="text-xs md:-text-sm text-subtitle break-all hover:text-primary">Pack of {{
            meme.children && (meme.children.length + 1) }}</span>

        </div>
        <div class="flex justify-between">
          <div></div>
          <a href="https://twitter.com/SappySealsNFT" target="_blank">
            <img src="../../assets/sealslogo.jpg"
              class="h-6 w-6 rounded-full md:outline outline-1 outline-divider hover:outline-primary" /></a>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import tiffy from "../../assets/tiffy.jpg";
import stormr from "../../assets/stormr.png";
import nesha from "../../assets/nesha.jpg";
import mungo from "../../assets/mung0x.png";
import fourleafclover from "../../assets/fourleafclover.jpg";
import uglywook from "../../assets/uglywook.jpg";
import jess from "../../assets/jess.jpg";
import iddyoddy from "../../assets/iddyoddy.png";
import anwar from "../../assets/anwar.png";
import drew from "../../assets/drew.png";
import kermit from "../../assets/kermit.png";
import bicolor from "../../assets/bicolor.png";
import fuji from "../../assets/fuji.png";
import sal from "../../assets/sal.png";
import macca from "../../assets/macca.png";
import rocket from "../../assets/rocket.png";
import joshua from "../../assets/joshua.png";
import wickedly from "../../assets/wickedly.png";
import swept from "../../assets/swept.png";
import cookees from "../../assets/cookees.png";
import pingwing from "../../assets/pingwing.jpg";

import { useToast } from "vue-toastification";

export default {
  methods: {
    OpenModal() {
      this.$store.dispatch("OpenMemeModal", this.index);
    },
    copyImage(img) {
      let newImage = new Image();
      newImage.fetchPriority = "high";
      newImage.src = img.src.replace("130/", "512/");
      newImage.crossOrigin = "anonymous";
      newImage.onload = () => {
        var imgCanvas = document.createElement("canvas");
        imgCanvas.id = "imgCanvas";
        imgCanvas.width = 512;
        imgCanvas.height = 512;
        var originalContext = imgCanvas.getContext("2d");
        originalContext.drawImage(
          newImage,
          0,
          0,
          imgCanvas.width,
          imgCanvas.height
        );
        imgCanvas.toBlob((blob) => {
          // Copy this blob to the clipboard
          navigator.clipboard.write([new ClipboardItem({ [blob.type]: blob })]);
          newImage.remove();
          let toast = useToast();
          toast.success("Copied!", {
            timeout: 1400,
          });
        });
      };
    },
    checkForMemePack(target, context) {
      if (context.meme.children && context.meme.children.length > 0) {
        // Insert memes into the array
        const tempChildren = context.meme.children.slice();
        // Remove children from the meme
        tempChildren.unshift(JSON.parse(JSON.stringify(context.meme)));
        tempChildren[0].children = [];
        this.$emit('selectPack', tempChildren);
      }
      else {
        this.copyImage(target);
      }
    }
  },
  props: ["meme", "index"],
  computed: {
    imageSrc() {
      let author = this.meme.author;
      if (author.includes(' & ')){
        author = author.split("&")[0].trim()
      }
      const authorToImage = {
        "@tiffyshmoop": tiffy,
        "@StormrDotEth": stormr,
        "@UglyWook": uglywook,
        "@JessGreenwalt": jess,
        "@4LeafCloverNFT": fourleafclover,
        "@mung0x": mungo,
        "@NeshaEth": nesha,
        "@AA_MasterLegend": anwar,
        "@IddyOddy": iddyoddy,
        "@drewso22": drew,
        "@crypto__kermit": kermit,
        "@BiColorSEAL": bicolor,
        "@FujiClap": fuji,
        "@paintingsbysal": sal,
        "@CMacca7": macca,
        "@RocketEGC": rocket,
        "@vJoshuavone": joshua,
        "@WickedlyNFT": wickedly,
        "@Deathwept": swept,
        "@cook_ees": cookees,
        "@itpingwing": pingwing,
      };
      return authorToImage[author] || tiffy;
    },
    isMemePack() {
      return this.meme.children && this.meme.children.length > 0;
    }
  },
};
</script>
